module.exports = __webpack_public_path__ + "img/banner2.21bcc801.jpg";